import { Action } from '@ngrx/store';
import { MsisdnRequestDto, OrderNumberRequest, PhoneNumber, PricingItem, PricingNumbers } from './pricing-numbers';
import { PaymentParams } from '../../account/account.model';

export const GET_PRICING_NUMBERS = 'GET_PRICING_NUMBERS';
export const GET_PRICING_NUMBERS_SUCCESS = 'GET_PRICING_NUMBERS_SUCCESS';
export const GET_PRICING_NUMBERS_FAILURE = 'GET_PRICING_NUMBERS_FAILURE';
export const GET_SINGLE_PRICING = 'GET_SINGLE_PRICING';
export const GET_SINGLE_PRICING_SUCCESS = 'GET_SINGLE_PRICING_SUCCESS';
export const GET_SINGLE_PRICING_FAILURE = 'GET_SINGLE_PRICING_FAILURE';

export const GET_NUMBERS = 'GET_NUMBERS';
export const GET_NUMBERS_SUCCESS = 'GET_NUMBERS_SUCCESS';
export const GET_NUMBERS_FAILURE = 'GET_NUMBERS_FAILURE';

export const CLEAR_NUMBERS_LOADED_STATE = 'CLEAR_NUMBERS_LOADED_STATE';
export const REGION_FOR_NUMBER_CHOSEN = 'REGION_FOR_NUMBER_CHOSEN';

export const ORDER_NUMBER = 'ORDER_NUMBER';
export const ORDER_NUMBER_PAYMENT = 'ORDER_NUMBER_PAYMENT';
export const ORDER_NUMBER_FAILURE = 'ORDER_NUMBER_FAILURE';
export const ORDER_INITIAL_NUMBER = 'ORDER_INITIAL_NUMBER';
export const ORDER_INITIAL_NUMBER_SUCCESS = 'ORDER_INITIAL_NUMBER_SUCCESS';
export const ORDER_INITIAL_NUMBER_FAILURE = 'ORDER_INITIAL_NUMBER_FAILURE';

export const SET_AVAILABLE_NUMBER_TYPES = 'SET_AVAILABLE_NUMBER_TYPES';

export class GetPricingNumbersAction implements Action {
  readonly type = GET_PRICING_NUMBERS;

  constructor(public payload: string) {}
}

export class GetPricingNumbersSuccessAction implements Action {
  readonly type = GET_PRICING_NUMBERS_SUCCESS;

  constructor(public payload: PricingNumbers) {}
}

export class GetPricingNumbersFailureAction implements Action {
  readonly type = GET_PRICING_NUMBERS_FAILURE;

  constructor(public payload: any) {}
}

export class GetNumbersAction implements Action {
  readonly type = GET_NUMBERS;

  constructor(public payload: { pricingId: number; searchText: string }) {}
}

export class GetNumbersSuccessAction implements Action {
  readonly type = GET_NUMBERS_SUCCESS;

  constructor(public payload: PhoneNumber[]) {}
}

export class GetNumbersFailureAction implements Action {
  readonly type = GET_NUMBERS_FAILURE;

  constructor(public payload: any) {}
}

export class ClearNumbersLoadedStateAction implements Action {
  readonly type = CLEAR_NUMBERS_LOADED_STATE;

  constructor() {}
}

export class RegionForNumberChosenAction implements Action {
  readonly type = REGION_FOR_NUMBER_CHOSEN;

  constructor(public payload: { fullyConfigured: boolean; pricingId: number }) {}
}

export class GetSinglePricingAction implements Action {
  readonly type = GET_SINGLE_PRICING;

  constructor(public payload: { pricingId: number }) {}
}

export class GetSinglePricingSuccessAction implements Action {
  readonly type = GET_SINGLE_PRICING_SUCCESS;

  constructor(public payload: PricingItem) {}
}

export class GetSinglePricingFailureAction implements Action {
  readonly type = GET_SINGLE_PRICING_FAILURE;

  constructor(public payload: any) {}
}

export class OrderNumberAction implements Action {
  readonly type = ORDER_NUMBER;

  constructor(public payload: OrderNumberRequest) {}
}

export class OrderNumberPaymentAction implements Action {
  readonly type = ORDER_NUMBER_PAYMENT;

  constructor(public payment: PaymentParams, public payload: MsisdnRequestDto) {}
}

export class OrderNumberFailureAction implements Action {
  readonly type = ORDER_NUMBER_FAILURE;

  constructor(public payload: any) {}
}

export class OrderInitialNumberAction implements Action {
  readonly type = ORDER_INITIAL_NUMBER;

  constructor(public payload: OrderNumberRequest) {}
}

export class OrderInitialNumberSuccessAction implements Action {
  readonly type = ORDER_INITIAL_NUMBER_SUCCESS;

  constructor(public payload?: any) {}
}

export class OrderInitialNumberFailureAction implements Action {
  readonly type = ORDER_INITIAL_NUMBER_FAILURE;

  constructor(public payload: any) {}
}

export class SetAvailableNumberTypesAction implements Action {
  readonly type = SET_AVAILABLE_NUMBER_TYPES;

  constructor(public payload: string[]) {}
}

export type PricingNumbersAction =
  | GetPricingNumbersAction
  | GetPricingNumbersSuccessAction
  | GetPricingNumbersFailureAction
  | GetNumbersAction
  | GetNumbersSuccessAction
  | GetNumbersFailureAction
  | ClearNumbersLoadedStateAction
  | RegionForNumberChosenAction
  | GetSinglePricingAction
  | GetSinglePricingSuccessAction
  | GetSinglePricingFailureAction
  | OrderInitialNumberAction
  | OrderInitialNumberSuccessAction
  | OrderInitialNumberFailureAction
  | SetAvailableNumberTypesAction;
